<template>
    <div class="xtxx">
<!-- 物业费-以户为单位-列表页 -->

<div class="content">

            <div v-if="!styleReady" class="loading-state">
                <van-loading type="spinner" color="#00b5ff">加载中...</van-loading>
            </div>

            <template v-else>
            <!-- 已开通开票小区：tab样式 -->
            <template v-if="isnewStyle">
            <div class="search datesearch" style="margin-top:10px">
                <span>缴费时间：</span>
                <input type="date" v-model="paymentDate">
                 <button class="searchbt" style="margin-left:20px" @click="onSearch">搜索</button>
            </div>

            <van-tabs v-model="activeTab">
                <van-tab title="未缴">
                    <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1">
                        <van-list
                            v-model="loading1"
                            :finished="finished1"
                            finished-text="没有更多了"
                            @load="onLoad1"
                        >
                            <div class="pj" v-for="(item,index) in list1" :key="index" @click="goList(item.id,item.type)">
                                <div class="xq">
                                    <span> {{item.time}}</span>
                                    <span>{{houseName}}</span>
                                    <button class="dpj1" v-if="item.isPay=='未缴'">未缴</button>
                                    <button class="dpj1" v-if="item.isPay=='已退款'">已退款</button>
                                </div>
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </van-tab>
                <van-tab title="已缴">
                    <van-pull-refresh v-model="refreshing2" @refresh="onRefresh2">
                        <van-list
                            v-model="loading2"
                            :finished="finished2"
                            finished-text="没有更多了"
                            @load="onLoad2"
                        >
                            <div class="pj" v-for="(item,index) in list2" :key="index" @click="goPaidDetail(item.id)">
                                <div class="xq">
                                    <span> {{item.time}}</span>
                                    <span>{{houseName}}</span>
                                    <button class="dpj">已缴</button>
                                </div>
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </van-tab>
            </van-tabs>
            </template>

            <!-- 未开通开票小区：原始列表样式 -->
            <template v-else>
            <div class="search datesearch" style="margin-top:10px">
                <span>缴费时间：</span>
                <input type="date" v-model="paymentDate">
                 <button class="searchbt" style="margin-left:20px" @click="onSearchOld">搜索</button>
            </div>

            <van-pull-refresh v-model="refreshing1" @refresh="onRefreshOld" >
                <van-list
                    v-model="loading1"
                    :finished="finished1"
                    finished-text="没有更多了"
                    @load="onLoadOld"
                >
                    <div class="pj" v-for="(item,index) in list1" :key="index" @click="goList(item.id,item.type)">
                        <div class="xq">
                            <span> {{item.time}}</span>
                            <span>{{houseName}}</span>
                            <button class="dpj" v-if="item.isPay=='已缴'">已缴</button>
                            <button class="dpj1" v-if="item.isPay=='未缴'">未缴</button>
                            <button class="dpj1" v-if="item.isPay=='已退款'">已退款</button>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            </template>
            </template>


</div>


    </div>
</template>
<script>

import { mapState, mapMutations } from "vuex";
export default {
    data() {
        return {
            isnewStyle: false,
            styleReady: false,
            activeTab:0,
            tp:'',
            search:'',
            list1:[],
            list2:[],
            houseName:'',
            loading1: false,
			loading2: false,
            finished1: false,
			finished2: false,
            refreshing1: false,
			refreshing2: false,
            paymentDate:'',
            currpage1:0,
            currpage2:0,
        }
    },
    computed: {
        ...mapState(['userInfo','identity','houseId','isactive'])
    },
    mounted() {
        this.tp = this.$route.query.tp
        this.houseName = sessionStorage.getItem('houseName')
        this.detectStyle()
    },
    methods: {

        // 探测当前房屋所在小区是否启用开票，决定走哪种列表样式（不依赖缴费记录）
        detectStyle() {
            this.$axios.get('/api/v1/wygl/propertyPayment/houseInvoiceEnabled').then(res => {
                this.isnewStyle = !!res;
                this.styleReady = true;
                if (!this.isnewStyle) {
                    this.onRefreshOld();
                }
            }).catch(() => {
                this.isnewStyle = false;
                this.styleReady = true;
                this.onRefreshOld();
            });
        },

        goList(id,type){
            this.$router.push({ path: "/wyfw/wyflist", query: {id:id,type:type} });
        },
        goPaidDetail(id){
            this.$router.push({ path: "/wyfw/feepaiddetail", query: {id:id} });
        },

        // ===== 其他小区：原始逻辑，不动 =====
        onSearchOld() {
            this.currpage1 = 0;
            this.refreshing1 = false;
            this.list1 = [];
            this.getdataOld();
        },
        getdataOld() {
            this.$axios.get('/api/v1/wygl/propertyPayment/viewList', {
                params:{
                    paymentDate:this.paymentDate,
                    pageNum:this.currpage1,
                    pageSize:15,
                    orderByColumn:'isPay,startMonth',
                    isAsc: 'asc'
                }
            }).then(res => {
                if (this.currpage1 == 0) {
                    this.list1 = res.data;
                } else {
                    if (res.data) {
                        this.list1 = this.list1.concat(res.data);
                    }
                }
                this.loading1 = false;
                this.refreshing1 = false;
                if (!res.data || res.data.length < 15) {
                    this.finished1 = true;
                } else {
                    this.currpage1++;
                    this.finished1 = false;
                }
            });
        },
        onLoadOld(){
           if (this.refreshing1) {
                this.currpage1 = 0;
                this.list1 = [];
                this.refreshing1 = false;
           }
           this.getdataOld();
        },
        onRefreshOld() {
            this.finished1 = false;
            this.loading1 = true;
            this.onLoadOld();
        },

        // ===== 皇冠公寓：tab样式 =====
        onSearch() {
            this.currpage1 = 0;
            this.currpage2 = 0;
            this.list1 = [];
            this.list2 = [];
            this.finished1 = false;
            this.finished2 = false;
            if (this.activeTab === 0) {
                this.refreshing1 = false;
                this.loading1 = true;
                this.getdata1();
            } else {
                this.refreshing2 = false;
                this.loading2 = true;
                this.getdata2();
            }
        },
        getdata1(){
            this.$axios.get('/api/v1/wygl/propertyPayment/viewList', {
                params:{
                    paymentDate:this.paymentDate,
                    pageNum:this.currpage1,
                    pageSize:15,
                    orderByColumn:'isPay,startMonth',
                    isAsc: 'desc'
                }
            }).then(res => {
                const data = res.data || [];
                const filtered = data.filter(item => item.isPay !== '已缴');
                if(this.currpage1 === 0){
                    this.list1 = filtered;
                } else {
                    this.list1 = this.list1.concat(filtered);
                }
                this.loading1 = false;
                this.refreshing1 = false;
                if(data.length < 15){
                    this.finished1 = true;
                } else {
                    this.currpage1++;
                }
            });
        },
        getdata2(){
            this.$axios.get('/api/v1/wygl/propertyPayment/viewList', {
                params:{
                    paymentDate:this.paymentDate,
                    pageNum:this.currpage2,
                    pageSize:15,
                    orderByColumn:'isPay,startMonth',
                    isAsc: 'asc'
                }
            }).then(res => {
                const data = res.data || [];
                const filtered = data.filter(item => item.isPay === '已缴');
                if(this.currpage2 === 0){
                    this.list2 = filtered;
                } else {
                    this.list2 = this.list2.concat(filtered);
                }
                this.loading2 = false;
                this.refreshing2 = false;
                if(data.length < 15){
                    this.finished2 = true;
                } else {
                    this.currpage2++;
                }
            });
        },
        onLoad1(){
           if (this.refreshing1) {
                this.currpage1 = 0;
                this.list1 = [];
                this.refreshing1 = false;
           }
           this.getdata1();
        },
        onRefresh1() {
            this.finished1 = false;
            this.loading1 = true;
            this.onLoad1();
        },
        onLoad2(){
           if (this.refreshing2) {
                this.currpage2 = 0;
                this.list2 = [];
                this.refreshing2 = false;
           }
           this.getdata2();
        },
        onRefresh2() {
            this.finished2 = false;
            this.loading2 = true;
            this.onLoad2();
        },

    },
}
</script>
<style lang="less">
    .content{
          height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
    }
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        .van-tabs{
            height: 100%;
            width: 100%;
        }
        .van-pull-refresh{
            height: calc(100vh - 160px) !important;
            overflow-y: auto;
        }
        .van-tab__pane{
            height: 100%;
        }
        .van-tabs__content{
            height: calc(100vh - 160px);
        }
        .van-pull-refresh__track{
            overflow: hidden;
            overflow-y: scroll;
        }
        .pj{
            display: flex;
            width: 94%;
			padding:14px 10px ;
            border-radius: 10px;
            display: flex;
            align-items: center;
            box-shadow: 0px 0px 5px #e6e6e6;
            margin-top: 10px;
            img{
                margin-left: 2%;
                height: 80px;
                width: 80px;
            }
            .xq{
                height: 100%;
                width: 100%;
                margin-left: 2%;
                display: flex;
                flex-direction: column;
                position: relative;
                span{
                    width:70%;
                }
                span:nth-child(1){
                    font-weight: bold;
                }
                span:nth-child(2){
                    margin-top: 5px;
                    color: #999999;
                }
                .dpj{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid #00d2ff;
                    color: #00d2ff;
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
                .dpj1{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid rgb(240, 182, 49);
                    color: rgb(240, 182, 49);
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
            }
        }
        .search{
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 13px;
            text-align: center;
            span{
                width: 30%;
            }
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .datesearch{
            input{
                width: 45%;
            }
        }
        .van-tabs__line{
            background-color: #28aff6;
            width: 90px;
            border-radius: 5px;
        }
        .van-list{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        ::-webkit-scrollbar{
            display: none;
        }
    }
</style>
